"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridLine = void 0;
const grid_js_1 = require("@ngageoint/grid-js");
/**
 * Line between two points
 */
class GridLine extends grid_js_1.Line {
    /**
     * Constructor
     *
     * @param line
     *            line to copy
     */
    constructor(line) {
        super(line);
    }
    /**
     * Create a line
     *
     * @param point1
     *            first point
     * @param point2
     *            second point
     * @param gridType
     *            line grid type (optional)
     * @return line
     */
    static lineFromPoints(point1, point2, gridType) {
        const gridLine = new GridLine(grid_js_1.Line.line(point1, point2));
        gridLine.gridType = gridType;
        return gridLine;
    }
    /**
     * Create a line
     *
     * @param line
     *            line to copy
     * @param gridType
     *            line grid type (optional)
     * @return line
     */
    static lineFromLine(line, gridType) {
        const gridLine = new GridLine(line);
        gridLine.gridType = gridType;
        return gridLine;
    }
    /**
     * Copy a line
     *
     * @param line
     *            line to copy
     * @return line
     */
    static lineFromGridLine(line) {
        return GridLine.lineFromLine(line, line.gridType);
    }
    /**
     * Get the line grid type
     *
     * @return grid type
     */
    getGridType() {
        return this.gridType;
    }
    /**
     * Check if the line has a grid type
     *
     * @return true if has grid type
     */
    hasGridType() {
        if (this.gridType) {
            return true;
        }
        return false;
    }
    /**
     * Set the line grid type
     *
     * @param gridType
     *            grid type
     */
    setGridType(gridType) {
        this.gridType = gridType;
    }
    /**
     * Copy the line
     *
     * @return line copy
     */
    copy() {
        return GridLine.lineFromGridLine(this);
    }
    /**
     * {@inheritDoc}
     */
    equals(obj) {
        if (this === obj)
            return true;
        if (!super.equals(obj))
            return false;
        if (typeof this !== typeof obj)
            return false;
        const other = obj;
        if (this.gridType !== other.gridType)
            return false;
        return true;
    }
}
exports.GridLine = GridLine;
//# sourceMappingURL=GridLine.js.map